(function ($) {
	// On Dom Ready
	$(function () {
		// Swiper slider
		$(".swiper.photoslider-c").each(function (index, element) {
			// disable if only one slide
			if ($(element).find(".swiper-slide").length > 1) {
				const the_slider = new Swiper(element, {
					loop: true,
					slidesPerView: 1,
					lazy: true,
					simulateTouch: false,
					// effect: "fade",

					autoplay: {
						delay: 5000,
					},
					speed: 700,

					// If we need pagination
					pagination: {
						el: $(element).find(".swiper-pagination")[0],
						clickable: true,
					},

					// Navigation arrows
					navigation: {
						nextEl: $(element).find(".swiper-button-next")[0],
						prevEl: $(element).find(".swiper-button-prev")[0],
					},
				});

				// play/pause swiper slider on button click
				$(element)
					.find(".play-pause-slideshow")
					.on("click", function (e) {
						e.preventDefault();
						$(this).toggleClass("active");

						if ($(this).hasClass("active")) {
							the_slider.autoplay.stop();
						} else {
							the_slider.autoplay.start();
						}
					});
			} else {
				$(element).addClass("disabled");
			}
		});
	});
})(jQuery);
